<template>
  <v-container>
    <v-card>
      <v-card-title class="error white--text">
        Profit or loss statement
        <v-spacer></v-spacer>
        <v-btn
          v-if="salesIncom.length"
          icon
          class="d-print-none"
          @click="PrintPage"
          small
          color="white"
        >
          <v-icon>fas fa-print</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-card flat>
          <v-data-table
            :loading="isloading"
            hide-default-footer
            :headers="headers"
            :items="salesIncom"
          >
            <template v-slot:top>
              <v-toolbar flat color="grey lighten-4">
                <v-toolbar-title v-if="fromDate != '' && toDate != ''"
                  >{{ fromDate }} --- {{ toDate }}</v-toolbar-title
                >

                <v-divider class="mx-4" inset vertical></v-divider>

                <searchDate
                  Thismonth
                  :searching="searching"
                  :SearchFun="OnSearch"
                ></searchDate>
                <v-spacer></v-spacer>
                <!-- {{ GrossProfit.toLocaleString() }} -->
              </v-toolbar>
            </template>
            <template v-slot:item.in="{ item }">
              {{ item | formatAmount }}
            </template>
            <template v-slot:item.KshAmount="{ item }">
              {{ BaseCash | MoneySigns }}
              {{ item.KshAmount.toLocaleString() }}
            </template>
            <template v-slot:item.Rate="{ item }">
              {{ item | TranRate(BaseCash) }}
            </template>
            <template v-slot:item.Amount="{ item }">
              {{ item.SourceType | MoneySigns }}
              {{ item.Amount.toLocaleString() }}
            </template>
            <template v-if="!isloading" #body.append>
              <tr v-if="salesIncom.length" class="grey lighten-1 FootTable">
                <td :colspan="headers.length - 1">Gross Profit</td>
                <td class="leftAlign">
                  {{ GrossProfit.toLocaleString() }} ksh
                </td>
              </tr>

              <tr>
                <td>Total Eexpense</td>
                <td></td>
                <td></td>

                <td>({{ TotalExpense.Amount.toLocaleString() }})</td>
              </tr>

              <tr
                :class="
                  NetProfit < 0 ? 'error white--text' : 'teal white--text'
                "
              >
                <td :colspan="headers.length - 1">Net Profit</td>
                <td class="leftAlign">{{ NetProfit.toLocaleString() }} Ksh</td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { EventBus } from "@/main";
import { mapGetters } from "vuex";
export default {
  components: {
    searchDate: () => import("@/components/util/searchDate.vue"),
    // PrintView: () => import("@/components/Branches/Sales/printSaleReport.vue")
  },
  filters: {
    TranRate(trn, BaseCash) {
      // console.log(trn, val);
      if (BaseCash == "USD")
        return (trn.Amount / trn.KshAmount).toFixed(2).toLocaleString();
      return (trn.KshAmount / trn.Amount).toFixed(2);
    },
  },
  data() {
    return {
      SalesRepo: "/exchange/OtherAmount",
      searching: false,
      isloading: false,
      fromDate: "",
      toDate: "",
      salesIncom: [],
      TotalExpense: { Amount: 0 },
      headers: [
        { text: "TranSaction", align: "left", value: "ExchangeType" },
        // { text: "Cash Type", value: "SourceType" },
        { text: "Amount", value: "Amount" },
        { text: "Rate", value: "Rate" },
        { text: "Price", value: "KshAmount" },
      ],
    };
  },

  computed: {
    ...mapGetters(["GetCashTypes", "LocalCurrencyGetter"]),
    BaseCash() {
      if (this.LocalCurrencyGetter.length)
        return this.LocalCurrencyGetter[0].Cashcode;
      return "KES";
    },
    SellTotal() {
      return this.salesIncom.reduce((total, val) => {
        if (val.ExchangeType === "Sell") return (total += val.Amount);
        return total;
      }, 0);
    },
    BuyTotal() {
      return this.salesIncom.reduce((total, val) => {
        if (val.ExchangeType === "Buy") return (total += val.Amount);
        return total;
      }, 0);
    },
    Total_Base_Sell() {
      return this.salesIncom.reduce((total, val) => {
        if (val.ExchangeType === "Sell") return (total += val.KshAmount);
        return total;
      }, 0);
    },
    Total_Base_Buy() {
      return this.salesIncom.reduce((total, val) => {
        if (val.ExchangeType == "Buy") return (total += val.KshAmount);
        return total;
      }, 0);
    },
    Rates() {
      if (this.BaseCash == "USD") {
        return {
          sellRate: this.SellTotal / this.Total_Base_Sell,
          buyRate: this.BuyTotal / this.Total_Base_Buy,
        };
      }
      return {
        sellRate: this.Total_Base_Sell / this.SellTotal,
        buyRate: this.Total_Base_Buy / this.BuyTotal,
      };
    },
    DeffRate() {
      // console.log(this.Rates);
      if (this.BaseCash == "USD")
        return parseFloat(this.Rates.buyRate - this.Rates.sellRate);
      return parseFloat(this.Rates.sellRate - this.Rates.buyRate);
    },
    Deff() {
      if (this.BaseCash == "USD")
        return this.Total_Base_Buy - this.Total_Base_Sell;
      return this.Total_Base_Sell - this.Total_Base_Buy;
      // return this.SellTotal - this.BuyTotal;
    },
    GrossProfit() {
      //   return this.salesIncom.reduce((t, s) => {
      //     if (s.AccountName === "Sales") return (t += s.Amount);
      //     return (t -= s.Amount);
      //   }, 0);

      if (this.BaseCash == "USD") {
        if (this.Deff > 0) return this.DeffRate * this.Total_Base_Sell;
        else return this.DeffRate * this.Total_Base_Buy;
      } else {
        if (this.Deff > 0) return this.DeffRate * this.BuyTotal;
        else return this.DeffRate * this.SellTotal;
      }
    },

    NetProfit() {
      return this.GrossProfit - this.TotalExpense.Amount;
    },
  },
  methods: {
    async PrintPage() {
      //   this.itemPerPage = this.Transactions.length;
      await EventBus.Printing(false);
      window.print();
      EventBus.Printing(true);
      //   this.itemPerPage = 10;
    },
    OnSearch(from, to) {
      this.fromDate = from;
      this.toDate = to;

      this.salesIncom = [];

      this.searching = true;
      this.isloading = true;

      this.GetReq()
        .then(result => {
          // console.log(result[0]);
          this.isloading = false;
          this.searching = false;
          this.salesIncom = result.data.Sale;
          this.TotalExpense = result.data.Expense;
        })
        .catch(() => {
          this.isloading = false;
          this.searching = false;
          // console.log(error);
        });
    },

    GetReq() {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: this.SalesRepo,
        query: { from: this.fromDate, to: this.toDate },
      });
    },
    loadSales() {
      try {
        this.searching = true;
        this.isloading = true;
        this.GetReq()
          .then(value => {
            this.searching = false;
            this.isloading = false;
            this.salesIncom = value.data.Sale;
            this.TotalExpense = value.data.Expense;
          })
          .catch(err => {
            this.searching = false;
            this.isloading = false;
            console.log(err);
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    //   console.log()
    const { date, Thismonth } = this.Current();
    this.fromDate = Thismonth;
    this.toDate = date;
    this.loadSales();
  },
};
</script>
<style scoped>
.FootTable td {
  font-weight: bold;
  border-top: 5px solid #f44336;

  /* font-size: 50px; */
}
.leftAlign {
  text-align: right;
}
</style>
